var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 83,
    viewBox: "0 0 71 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 145,
    rx: 12.5,
    transform: "matrix(0.777146 0.62932 0.62932 -0.777146 -35.4883 71.5078)",
    fill: "#3F78E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlue);
export default __webpack_public_path__ + "static/media/LeftBlue.2f3587d5542b05562b897b171dfaa35e.svg";
export { ForwardRef as ReactComponent };